import React from 'react';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const DateTimeField = ({ field, data, change, hasError, errorMessage }) => {
    const toDatetimeLocalValue = (v) => {
        if (!v) return '';
        const normalized = v.includes('T') ? v : v.replace(' ', 'T');
        return normalized.slice(0, 16);
    };

    return (
        <TextField
            {...outlinedFieldProps}
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            type="datetime-local"
            value={toDatetimeLocalValue(data[field.key])}
            onChange={(e) => change(field.key, e.target.value)}
            error={hasError}
            helperText={hasError ? (errorMessage || 'This field is required') : ''}
            InputLabelProps={{ shrink: true }}
        />
    );
};

export default DateTimeField;
